import { render, staticRenderFns } from "./crownAlign.vue?vue&type=template&id=46e3ac40&scoped=true&"
import script from "./crownAlign.vue?vue&type=script&lang=js&"
export * from "./crownAlign.vue?vue&type=script&lang=js&"
import style0 from "./crownAlign.vue?vue&type=style&index=0&id=46e3ac40&prod&lang=scss&scoped=true&"
import style1 from "./crownAlign.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e3ac40",
  null
  
)

export default component.exports